import React, { useState, useEffect } from 'react';
import { collection, getDocs, getFirestore, query, orderBy, where, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { app } from '../../firebase';
import './feedback.css';

const db = getFirestore(app);

function Feedback() {
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRating, setSelectedRating] = useState('');
  const [sortByDateAsc, setSortByDateAsc] = useState(true);
  const [replyText, setReplyText] = useState('');
  const [showReplyBox, setShowReplyBox] = useState({});

  useEffect(() => {
    const fetchFeedbackData = async () => {
      try {
        let feedbackQuery = query(collection(db, 'feedback'), orderBy('dateTime', sortByDateAsc ? 'asc' : 'desc'));
        if (selectedRating !== '') {
          feedbackQuery = query(feedbackQuery, where('rating', '==', selectedRating));
        }
        const querySnapshot = await getDocs(feedbackQuery);
        const feedbackList = [];
        querySnapshot.forEach((doc) => {
          feedbackList.push({ id: doc.id, ...doc.data() });
        });
        setFeedbackData(feedbackList);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching feedback data:', error);
        setLoading(false);
      }
    };

    fetchFeedbackData();
  }, [selectedRating, sortByDateAsc]);

  const handleDelete = async (feedbackId) => {
    try {
      await deleteDoc(doc(db, 'feedback', feedbackId));
      setFeedbackData(feedbackData.filter((feedback) => feedback.id !== feedbackId));
    } catch (error) {
      console.error('Error deleting feedback:', error);
    }
  };

  const handleReplyToggle = (feedbackId) => {
    setShowReplyBox((prevState) => ({
      ...prevState,
      [feedbackId]: !prevState[feedbackId] // Toggle the value
    }));
  };

  const handleReply = async (feedbackId) => {
    try {
      const docRef = doc(db, 'feedback', feedbackId);
      await updateDoc(docRef, { reply: replyText });
      setReplyText('');
      setShowReplyBox((prevState) => ({ ...prevState, [feedbackId]: false }));
    } catch (error) {
      console.error('Error adding reply:', error);
    }
  };

  return (
    <div className="feedback-container">
      <h2>User Feedback</h2>
      <div className="filter-container">
        <button onClick={() => setSortByDateAsc(!sortByDateAsc)}>
          {sortByDateAsc ? 'Sort by Date Ascending' : 'Sort by Date Descending'}
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <ul className="feedback-list">
          {feedbackData.map((feedback) => (
            <li key={feedback.id} className="feedback-item">
              <div className="feedback-card">
                <h3 className="feedback-title">{feedback.name}</h3>
                <p className="feedback-details"><span>Email:</span> {feedback.email}</p>
                
                <p className="feedback-details"><span>Date & Time:</span> {feedback.dateTime}</p>
                <p className="feedback-details"><span>Rating:</span> {feedback.rating}</p>
                <p className="feedback-details"><span>Comments:</span> {feedback.comments}</p>
                <div className="feedback-actions">
                  <button onClick={() => handleReplyToggle(feedback.id)}>
                    {showReplyBox[feedback.id] ? 'Cancel Reply' : 'Reply'}
                  </button>
                  <button onClick={() => handleDelete(feedback.id)}>Delete</button>
                </div>
                {showReplyBox[feedback.id] && (
                  <div className="reply-box">
                    <textarea
                      value={replyText}
                      onChange={(e) => setReplyText(e.target.value)}
                      placeholder="Enter your reply here..."
                    />
                    <button onClick={() => handleReply(feedback.id)}>Send Reply</button>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Feedback;
